import { render, staticRenderFns } from "./yjtsy.vue?vue&type=template&id=39187830&scoped=true&"
import script from "./yjtsy.vue?vue&type=script&lang=js&"
export * from "./yjtsy.vue?vue&type=script&lang=js&"
import style0 from "./yjtsy.vue?vue&type=style&index=0&id=39187830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39187830",
  null
  
)

export default component.exports